import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). No color-bearing entries on
// web, but index.js resolves './styles' to this file on web and consumes it
// via useThemedStyles, so the factory shape must match styles.js.
const makeStyles = () =>
  StyleSheet.create({
    mainView: {
      paddingVertical: 40,
      ...CommonStyles.ph_32,
      ...CommonStyles.full_flex,
    },
    titleContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mb_24,
    },
    tabText: {
      paddingHorizontal: 44,
      ...CommonStyles.mb_8,
    },
  });

export default makeStyles;
